import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b5de9d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 巡检视频 ")
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "box" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_popup, {
      show: _ctx.show,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.show) = $event)),
      round: "",
      position: "bottom",
      style: { height: '90%' },
      class: "popup"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
          }, [
            _createVNode(_component_van_icon, { name: "cross" })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_pull_refresh, {
            modelValue: _ctx.refreshing,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.refreshing) = $event)),
            onRefresh: _ctx.onRefresh
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_list, {
                loading: _ctx.loading,
                "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loading) = $event)),
                finished: _ctx.finished,
                "finished-text": "没有更多了",
                onLoad: _ctx.onLoad
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_checkbox_group, {
                    modelValue: _ctx.result,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.result) = $event)),
                    onChange: _ctx.chanageList
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkList, (item, index) => {
                        return (_openBlock(), _createBlock(_component_van_checkbox, {
                          key: index,
                          name: item.fileName,
                          disabled: item.flag
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", null, _toDisplayString(item.fileName), 1),
                              _createElementVNode("div", null, "开始时间：" + _toDisplayString(item.fileStartTime), 1),
                              _createElementVNode("div", null, "结束时间：" + _toDisplayString(item.fileEndTime), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["name", "disabled"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }, 8, ["loading", "finished", "onLoad"])
            ]),
            _: 1
          }, 8, ["modelValue", "onRefresh"])
        ]),
        _createVNode(_component_van_button, {
          block: "",
          type: "primary",
          onClick: _ctx.onFinish
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}